<template>
  <BContainer
    class="vh-100 d-flex justify-content-center align-items-center flex-column"
  >
    <BImg
      :src="require('@/assets/images/error/error-02.png')"
      class="mb-5"
      style="width: 30vw;"
    />
    <p class="text-center h3 text-primary">
      Oops! Location is currently disabled.
    </p>
    <p class="text-center text-muted">
      The requested page is not accessible without your location. Please enable your location to continue.
    </p>
    <BButton
      v-if="notDenied"
      variant="success"
      @click.prevent="allowLocation"
    >
      Allow Location
    </BButton>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SharedLocationNotAllowed',

  data () {
    return {
      notDenied: false
    }
  },

  computed: mapGetters({
    user: 'auth/user'
  }),

  methods: {
    allowLocation () {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        if (result.state !== 'granted') {
          this.notDenied = true
        } else {
          this.notDenied = false
        }
      })
    }
  }
}
</script>
